


















import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import Checkout from '../components/DirectPassCheckout.vue'
import PayerDetails from '../components/PayerDetails.vue'

@Component({
  components: {
    Checkout,
    PayerDetails
  }
})
export default class CheckoutPage extends Vue {
  details = null

  data = null as any

  error = false

  confirmDetails(data: any) {
    this.details = data
  }

  mounted() {
    this.loadInitialData()
  }

  async loadInitialData() {
    try {
      const response = await axios.get(`/payments/courses/${this.$route.params.courseId}/costs`)
      this.data = response.data
    } catch {
      this.error = true
    }
  }

  get isThirdParty() {
    return this.$store.state.auth.userId !== this.data.userId
  }
}
